import {
	RIBBON_DND_TILE_TYPE,
	type RibbonAppTileDndData,
	type RibbonHideTileDndData,
} from './types';

/**
 * Type guards for ribbon-specific Pragmatic DnD payloads.
 *
 * These are used in `canDrop` / `canMonitor` checks to ensure we only respond
 * to ribbon tile drags.
 */
export function isRibbonAppTileDndData(
	data: Record<string | symbol, unknown>,
): data is RibbonAppTileDndData {
	return (
		data.type === RIBBON_DND_TILE_TYPE.APP_TILE &&
		typeof data.productId === 'string' &&
		typeof data.index === 'number'
	);
}

/**
 * Type guard for the footer "Hide" drop target payload.
 */
export function isRibbonHideTileDndData(
	data: Record<string | symbol, unknown>,
): data is RibbonHideTileDndData {
	return data.type === RIBBON_DND_TILE_TYPE.HIDE_TILE;
}
